import React, { useState } from 'react';
import { Icon } from './icon';

type CollapsibleErrorProps = {
  error: unknown;
  summary?: string;
};

export const CollapsibleError: React.FC<CollapsibleErrorProps> = ({
  error,
  summary,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const errorString =
    typeof error === 'string' ? error : JSON.stringify(error, null, 2);

  return (
    <div className="flex flex-col gap-2 mt-2">
      {summary && <p className="text-sm text-gray-500">{summary}</p>}
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="flex items-center gap-1 text-xs text-gray-600 hover:text-gray-800 font-medium w-fit"
      >
        <Icon
          icon="chevron-right"
          size="regular"
          className={`transition-transform ${isExpanded ? 'rotate-90' : ''}`}
        />
        {isExpanded ? 'Hide' : 'Show'} error details
      </button>
      {isExpanded && (
        <pre className="text-xs bg-gray-50 p-2 rounded border border-gray-200 overflow-auto max-h-48 text-gray-700 font-mono whitespace-pre-wrap break-words">
          {errorString}
        </pre>
      )}
    </div>
  );
};
